<template>
  <figure class="app-image" :style="{ aspectRatio: ratio ? ratio.replace('by', ' / ') : null }">
    <picture>
      <source v-if="webpFallback" :srcset="src" type="image/webp">
      <img
        ref="image"
        v-bind="$attrs"
        :src="fallbackSrc"
        :alt="alt"
        :loading="!noLazy ? 'lazy' : 'eager'"
        decoding="async"
        v-on="$listeners"
        @load="onLoad"
      >
    </picture>
    <div v-if="!isLoaded && !noLazy" class="app-image-placeholder no-js-hide">
      <slot name="placeholder">
        <b-skeleton />
      </slot>
    </div>
  </figure>
</template>

<script>
export default {
  name: 'AppImage',
  inheritAttrs: false,
  props: {
    src: { type: String, default: null },
    alt: { type: String, default: '' },
    webpFallback: { type: String, default: null },
    ratio: { type: String, default: null },
    noLazy: { type: Boolean }
  },
  data () {
    return {
      isLoaded: false
    }
  },
  computed: {
    fallbackSrc () {
      return this.webpFallback || this.src
    }
  },
  mounted () {
    const img = this.$refs.image
    if (img && img.complete && img.naturalWidth > 0) {
      this.onLoad()
    }
  },
  methods: {
    onLoad () {
      this.isLoaded = true
    }
  }
}
</script>

<style scoped>
.app-image {
  position: relative;
  margin: 0;
}

.app-image,
.app-image picture,
.app-image img {
  display: block;
  width: 100%;
  /* height: 100%; */
}

.app-image img {
  object-fit: cover;
}
.app-image-placeholder {
  position: absolute;
  inset: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
}
/* domyślny skeleton wypełnia obszar bez potrzeby klasy skeleton-image-placeholder */
.app-image-placeholder :deep(.b-skeleton) {
  position: absolute;
  inset: 0;
  height: 100%;
  background: #fff;
}
.app-image-placeholder :deep(.b-skeleton-item) {
  height: 100%;
}
</style>
